import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/query-yy.png';

const _withScopeId = n => (_pushScopeId("data-v-5b8fe019"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "60px"
  }
}, null, -1));

const _hoisted_2 = {
  class: "head clearfix"
};
const _hoisted_3 = {
  class: "head-top-box"
};
const _hoisted_4 = {
  class: "head-top"
};
const _hoisted_5 = {
  class: "head-logo"
};
const _hoisted_6 = {
  href: "/index.html"
};
const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split-line"
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "耕云学堂", -1));

const _hoisted_10 = {
  class: "head-nav"
};
const _hoisted_11 = ["href", "target"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-btn"
}, " 更多 ", -1));

const _hoisted_14 = ["href", "target"];
const _hoisted_15 = {
  class: "head-infor"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11ZM18.0319 16.6177C19.2635 15.078 20 13.125 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.125 20 15.078 19.2635 16.6177 18.0319L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L18.0319 16.6177Z",
  fill: "#86909C",
  style: {
    "fill": "color(display-p3 0.5255 0.5647 0.6118)",
    "fill-opacity": "1"
  }
}, null, -1));

const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = ["href", "target"];
const _hoisted_19 = ["href"];
const _hoisted_20 = ["href"];
const _hoisted_21 = {
  key: 0,
  class: "query"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11ZM18.0319 16.6177C19.2635 15.078 20 13.125 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.125 20 15.078 19.2635 16.6177 18.0319L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L18.0319 16.6177Z",
  fill: "#86909C",
  style: {
    "fill": "color(display-p3 0.5255 0.5647 0.6118)",
    "fill-opacity": "1"
  }
}, null, -1));

const _hoisted_23 = [_hoisted_22];
const _hoisted_24 = {
  key: 1,
  class: "overall"
};
const _hoisted_25 = {
  class: "input-div"
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "24",
  height: "24"
}, null, -1));

const _hoisted_27 = [_hoisted_26];
const _hoisted_28 = {
  key: 2,
  class: "head-login"
};
const _hoisted_29 = {
  key: 3,
  class: "head-user"
};
const _hoisted_30 = {
  class: "avatar-box"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "user-name"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-qiehuan"
}, null, -1));

const _hoisted_34 = /*#__PURE__*/_createTextVNode("账号设置");

const _hoisted_35 = /*#__PURE__*/_createTextVNode("退出");

const _hoisted_36 = {
  class: "fixPostion"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_el_input = _resolveComponent("el-input");

  const _component_ArrowUp = _resolveComponent("ArrowUp");

  const _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", {
      'header-set': $props.page == '设置',
      'header-home': $data.currentPage == '首页'
    }])
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", _hoisted_6, [_createElementVNode("img", {
    src: $data.logoUrl,
    alt: ""
  }, null, 8, _hoisted_7)]), _hoisted_8, _hoisted_9]), _createElementVNode("div", {
    class: _normalizeClass(["head-btn", {
      'btn-none': $props.page == '设置',
      isFixed: $data.titleFixed == true
    }])
  }, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.showNavList, ({
    nav_name,
    target_url,
    target_type
  }, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["nav-btn", $data.currentPage === nav_name ? 'nav-active' : ''])
    }, [_createElementVNode("a", {
      href: target_url,
      class: "noticenav",
      target: target_type ? '_blank' : '_self'
    }, _toDisplayString(nav_name), 9, _hoisted_11), _hoisted_12], 2);
  }), 128)), $options.hideNavList.length > 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 0,
    "popper-class": "hidemenu_drop"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.hideNavList, hideItem => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: hideItem.id
        }, {
          default: _withCtx(() => [_createElementVNode("a", {
            href: hideItem.target_url,
            class: "noticenav",
            target: hideItem.target_type ? '_blank' : '_self'
          }, _toDisplayString(hideItem.nav_name), 9, _hoisted_14)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_13]),
    _: 1
  })) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_15, [$data.userInfo ? (_openBlock(), _createElementBlock("svg", {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleImgQuery && $options.handleImgQuery(...args)),
    class: "search-btn"
  }, _hoisted_17)) : _createCommentVNode("", true), $data.headList.length && ($data.zhsRole == 1 || $data.userRole == 1) ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.headList, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: "guard-center",
      key: index,
      href: item.target_url ? item.target_url : '',
      target: item.target_type ? '_blank' : '_self'
    }, _toDisplayString(item.name), 9, _hoisted_18);
  }), 128)) : _createCommentVNode("", true), $data.onlineTeache && ($data.zhsRole || $data.userRole) ? (_openBlock(), _createElementBlock("a", {
    key: 2,
    class: "online",
    href: $data.onlineTeache ? $data.onlineTeache.target_url : '',
    target: "_blank"
  }, _toDisplayString($data.onlineTeache.name), 9, _hoisted_19)) : _createCommentVNode("", true), $data.userInfo && $data.userInfo.roleId ? (_openBlock(), _createElementBlock("a", {
    key: 3,
    class: "online",
    href: $data.backUrl,
    target: "_blank"
  }, " 管理后台 ", 8, _hoisted_20)) : _createCommentVNode("", true), $data.showLogin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [!$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleImgQuery && $options.handleImgQuery(...args))
  }, _hoisted_23))])) : _createCommentVNode("", true), $data.showInput ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.handleLick && $options.handleLick(...args), ["stop"])),
    class: "mask"
  }), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_input, {
    modelValue: $data.teacherName,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.teacherName = $event),
    size: "medium",
    class: "search-input",
    clearable: "",
    onKeyup: _withKeys($options.handleSearch, ["enter"]),
    placeholder: "请输入关键字"
  }, null, 8, ["modelValue", "onKeyup"]), _createElementVNode("div", {
    class: "input-img",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.handleSearch && $options.handleSearch(...args))
  }, _hoisted_27)])])) : _createCommentVNode("", true), !$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", {
    class: "login-btn",
    onClick: _cache[5] || (_cache[5] = $event => $options.handleLogin())
  }, "登录")])) : _createCommentVNode("", true), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
    class: "avatar",
    src: $data.userInfo.avatar ? $data.userInfo.avatar : require('../../assets/images/user_icon.png')
  }, null, 8, _hoisted_31)]), _createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        onClick: $options.goAccountSet
      }, {
        default: _withCtx(() => [_hoisted_34]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
        onClick: $options.handleLogout
      }, {
        default: _withCtx(() => [_hoisted_35]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_32, _toDisplayString($data.userInfo.realname), 1), _hoisted_33]),
    _: 1
  })])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", {
    class: "back-top",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.backTop && $options.backTop(...args))
  }, [_createVNode(_component_el_icon, {
    size: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowUp)]),
    _: 1
  })])])])], 2);
}